import './styles.scss'
import React, { Fragment } from 'react'
import { I18n } from 'react-redux-i18n'

import { getStaticImage } from 'utils/statics'
import { FreeTrialBanner } from 'components/Banners'
import { getMenuItemIcon } from './utils'
import BetaMark from 'components/common/BetaMark'

/**
 *
 * @param {object} props
 * @param {string} props.name
 */
const MenuIcon = (props) => {
  const { name } = props

  if (!name) return null

  const icon = getMenuItemIcon(name)

  return (
    <figure
      className={`main-menu__item-icon main-menu__item-icon--${name}`}
    >
      {
        typeof icon === 'string'
          ? (
            <img
              src={getStaticImage(`/icons/orange-brand/icon-${icon}-white.svg`)}
              alt={I18n.t(name)}
            />
          )
          : icon
      }
    </figure>
  )
}

const MainMenuUI = ({
  isOpen,
  user,
  company,
  sidebar,
  poolLists,
  menuLevelsOpened,
  pathname,
  freeTrialDays,
  isOverlay,
  setIsOverlay,
  getMnemonics,
  handleMenuItem
}) => {
  const renderMenuLevel = ({ menuId, menuLevel, menuData }) => {
    if (!menuData) return

    return (
      <ul
        className={`
          main-menu__level-container
          ${menuLevel > 0 ? 'main-menu__level-container--level' : ''}
          ${
            (
              menuId === menuLevelsOpened[`level${menuLevel}`]
              || menuLevel === 0
            ) ? 'main-menu__level-container--is-open' : ''
          }
        `}
      >
        {menuData?.map((dataItem, index) => {
          if (dataItem.blackListRole?.includes(user.role)) return null

          return (
            <Fragment key={index}>
              <li
                className={`
                  main-menu__item
                  ${
                    (
                      dataItem.name === menuLevelsOpened[`level${menuLevel + 1}`]
                    ) ? 'main-menu__item--level' : ''
                  }
                `}
              >
                <button
                  type='button'
                  title={I18n.t(dataItem.name)}
                  className={`
                    main-menu__item-btn
                    ${!dataItem.children?.length && pathname.includes(dataItem.url) ? 'main-menu__item-btn--selected' : ''}
                  `}
                  onClick={() => {
                    handleMenuItem({
                      menuId: dataItem.children?.length ? dataItem.name : '',
                      menuLevel: menuLevel + 1,
                      url: dataItem.url,
                      type: dataItem.type,
                      module: dataItem.module
                    })
                  }}
                >
                  <div className={`main-menu__icon-container main-menu__icon-container--${dataItem.name}`}>
                    <div className='main-menu__mnemonics-wrapper'>
                      {getMnemonics(dataItem.name)}
                    </div>
                    <MenuIcon
                      name={dataItem.name}
                    />
                  </div>
                  <div
                    className={`
                      main-menu__content
                      ${(isOpen || isOverlay) ? 'main-menu__content--is-open' : ''}
                    `}
                  >
                    <p className='text-ellipsis'>{I18n.t(dataItem.name)}</p>
                    {
                      dataItem.isBeta
                        ? (
                          <BetaMark
                            className='main-menu__beta-mark'
                          />
                        )
                        : null
                    }
                    {dataItem.children?.length ? (
                      <figure className='main-menu__item-arrow'>
                        <img src={getStaticImage('/icons/orange-brand/icon-arrow-down-white.svg')} alt='Arrow' />
                      </figure>
                    ): null}
                  </div>
                </button>
              </li>
              {renderMenuLevel({
                menuId: dataItem.name,
                menuLevel: menuLevel + 1,
                menuData: dataItem.children
              })}
            </Fragment>
          )
        })}
      </ul>
    )
  }

  return (
    <div
      className={`
        main-menu
        ${!isOpen ? 'main-menu--floating' : ''}
      `}
      onMouseEnter={() => !isOpen && setIsOverlay(true)}
      onMouseLeave={() => !isOpen && setIsOverlay(false)}
    >
      {renderMenuLevel({ menuLevel: 0, menuData: sidebar })}
      {(isOpen || isOverlay) ? (
        <FreeTrialBanner
          customContainerStyles='main-menu__free-trial-banner'
          freeTrialDays={freeTrialDays}
        />
      ) : null}
    </div>
  )
}

export default MainMenuUI
